import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import clsx from 'clsx';
import { useTargetStore } from '../../store/targetStore';

function countdown(toIso: string | null | undefined, now: number): { label: string; urgent: boolean } | null {
  if (!toIso) return null;
  const t = new Date(toIso).getTime();
  if (Number.isNaN(t)) return null;
  const diff = t - now;
  if (diff <= 0) return null;
  const s = Math.floor(diff / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return { label: `${pad(h)}:${pad(m)}:${pad(sec)}`, urgent: diff < 10 * 60 * 1000 };
}

export default function ExerciseClock() {
  const { targets } = useTargetStore();
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const upcoming = targets
    .map((t) => {
      const opens = t.status === 'INACTIVE' ? countdown(t.openingTime, now) : null;
      const closes = ['ACTIVE', 'ASSIGNED', 'EXECUTING'].includes(t.status) ? countdown(t.closingTime, now) : null;
      return { t, opens, closes };
    })
    .filter((x) => x.opens || x.closes);

  return (
    <div className="rounded-xl border border-command-border bg-command-panel p-4">
      <div className="flex items-baseline justify-between mb-3">
        <h3 className="text-sm font-semibold text-gray-100">Exercise Clock</h3>
        <div className="font-display text-2xl font-bold text-command-accent tabular-nums">{format(now, 'HH:mm:ss')}</div>
      </div>
      <div className="text-[10px] text-gray-500 mb-2">{format(now, 'EEE dd MMM yyyy')}</div>
      <div className="space-y-1">
        {upcoming.map(({ t, opens, closes }) => (
          <div key={t.id} className="flex items-center justify-between text-xs">
            <span className="text-gray-300 truncate mr-2">{t.name}</span>
            {opens && <span className="text-blue-300 tabular-nums">opens {opens.label}</span>}
            {closes && (
              <span className={clsx('tabular-nums', closes.urgent ? 'text-red-400 font-semibold' : 'text-amber-400')}>
                closes {closes.label}
              </span>
            )}
          </div>
        ))}
        {upcoming.length === 0 && <p className="text-[11px] text-gray-500">No pending target windows.</p>}
      </div>
    </div>
  );
}
